<template>
  <div>
    <el-form-item label="经验值">
      <el-input v-model="form.exp"></el-input>
    </el-form-item>
    <el-form-item label="元宝">
      <el-input v-model="form.coin"></el-input>
    </el-form-item>
    <el-form-item label="元宝系数">
      <el-input v-model="form.coinx"></el-input>
    </el-form-item>
    <el-form-item label="应用场景">
      <el-checkbox-group v-model="scenes">
        <el-checkbox :label="1" :key="1">词汇应用</el-checkbox>
        <el-checkbox :label="2" :key="2">语法应用</el-checkbox>
        <el-checkbox :label="3" :key="3">口语表达</el-checkbox>
        <el-checkbox :label="4" :key="4">内容理解</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="not_report">不计算正确率</el-checkbox>
    </el-form-item>
    <ActionRules 
      :source="source"
      :selection="selection"
      v-model="action"
      ></ActionRules>
  </div>
</template>

<script>
import ActionRules from '../units/ActionRules.vue'
import utils from '@/js/utils.js'

export default {
  name: 'exercise-setting',
  props: {
    form: Object
  },
  components: {ActionRules},
  data () {
    return {
      source: [],
      selection: null,
      action: [],
      not_report: false,
      scenes: [],
    }
  },
  watch: {
    form () {
      this.initSource()
    }
  },
  mounted () {
    this.initSource()
  },
  methods: {
    getFormData () {
      return Object.assign({data: ''}, utils.filterData({
        exp: this.form.exp, 
        coin: this.form.coin, 
        coinx: this.form.coinx,
        data: {
          action: this.action,
          scenes: this.scenes,
          not_report: this.not_report || null,
        },
      }))
    },
    initSource () {
      let data = ((this.form || {}).entity_data || {})
      this.scenes = data.scenes || []
      this.action = JSON.parse(JSON.stringify(data.action || []))
      this.not_report = data.not_report || false
      let node = this.$parent
      while(!(/LessonCollection|LessonEntities/.test(node.$options.name))) {
        node = node.$parent
      }
      let id = this.form.id
      let collection = node.coll || node.collection[node.activeColl]
      let index = collection.entities.findIndex(n => n.id == id)
      this.source = collection.entities.slice(0, index + 1)
        .map((n, k) => {
          return {id: n.id, num: k + 1, type: n.entity_type}
        }).reverse()
        .filter(n => n.type == 'exercise').map(n => {
          return {id: n.id, name: '' + n.num}
        })
      this.selection = this.source.length > 0 ? this.source[0].id : 0
    }
  }
}
</script>
